module.exports = __webpack_public_path__ + "img/editar.8e31ba79.svg";